import React, {useEffect, useState} from 'react'
import {HubConnectionBuilder, HubConnection} from '@microsoft/signalr'
import {RemindarScheduleAppointmentModal} from '../../../../app/common/Models/remindar-schedule-appointment-modal/RemindarScheduleAppointmentModal'
import AppointmentReminderPopup from '../../../../app/UI/Common/components/Appointments/AppointmentReminderPopup'
import {useAuth} from '../../../../app/modules/auth'

const RemindarSignalRHub: React.FC = () => {
  const {auth, currentUser} = useAuth()
  const [isOpenRemindarScheduleAppointmentModal, setIsOpenRemindarScheduleAppointmentModal] =
    useState(false)
  const [signalRConnection, setSignalRConnection] = useState<HubConnection | null>(null)
  const [remindarMessage, setRemindarMessage] = useState<string>('')
  const [appointmentIds, setAppointmentIds] = useState<number[]>([]) // Using number type for IDs
  const [latestAppointmentId, setLatestAppointmentId] = useState<number>(0)
  const [results, setResults] = useState<{message: string; type: string; appointmentId: number; HasSessionStarted: boolean; Channel: string; CommunicationTypeIdentification?: string; ClientName: string; RequesterName: string}[] | []>([])
  const [viewResults, setViewResults] = useState<{message: string; appointmentId: number}[]>([])
  const [showUpcomingPopup, setShowUpcomingPopup] = useState(false)
  const [upcomingAppointmentId, setUpcomingAppointmentId] = useState<number | undefined>(undefined)
  const [upcomingAppointmentTime, setUpcomingAppointmentTime] = useState<string | undefined>(undefined)
  const [showFiveMinReminder, setShowFiveMinReminder] = useState(false)
  const [currentReminder, setCurrentReminder] = useState<any | null>(null)

  useEffect(() => {
    if (results) {
      // Filter out the elements from `results` that are already in `viewResults`
      const filteredResults = results.filter((item: any) => {
        return !viewResults.some((view: any) => view.appointmentId === item.appointmentId)
      })
      //Direct check without state mutation race condition
      if (filteredResults?.length > 0) {
        setIsOpenRemindarScheduleAppointmentModal(true)
        setRemindarMessage(filteredResults[0].message)
        setLatestAppointmentId(filteredResults[0].appointmentId)
      }

      // Interpreter-only upcoming popup within 5 minutes
      if (currentUser?.result?.userType === 'INTERPRETER') {
        const now = Date.now()
        const upcoming = filteredResults.find((item: any) => {
          const t = new Date(item.message).getTime()
          const diffMin = (t - now) / 60000
          return diffMin >= 0 && diffMin <= 5
        })
        if (upcoming) {
          setUpcomingAppointmentId(upcoming.appointmentId)
          setUpcomingAppointmentTime(upcoming.message)
          setShowUpcomingPopup(true)
        }
      }
    }
  }, [results])

  const handleCloseModal = () => {
    setViewResults([...viewResults, {message: remindarMessage, appointmentId: latestAppointmentId}])
    setIsOpenRemindarScheduleAppointmentModal(false)
    setLatestAppointmentId(0)
  }


  useEffect(() => {
    // Don't create SignalR connection if userType is SYSTEM
    if (currentUser?.result?.userType === 'SYSTEM') return
    
    // Create the SignalR connection
    if (!auth?.token) return
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_WEB_SOCKET_URL}/reminderHub`, {
        accessTokenFactory: () => auth?.token ?? '',
      }) // Make sure the URL matches the SignalR hub on the server
      .build()

    newConnection.start().catch((error: any) => console.error('SignalR:', error))

    setSignalRConnection(newConnection)

    // Listen for messages from the server
    newConnection.on('ReceiveReminder', async (message: string, user: string) => {
      const result = JSON.parse(message)
      console.log('SignalR Remindar Message Received:', result)
      if(result[0]?.type === "call-start-reminder"){
          setIsOpenRemindarScheduleAppointmentModal(true)

      }
      if (result?.length > 0) setResults(result)
    })

    // Cleanup connection when the component is unmounted
    return () => {
      newConnection.stop()
    }
  }, [auth, currentUser?.result?.userType])

  // Don't render if userType is SYSTEM
  if (currentUser?.result?.userType === 'SYSTEM') {
    return null
  }

  return (
    <>{
      results && results[0]?.type === "call-start-reminder" ? (<AppointmentReminderPopup
        show={isOpenRemindarScheduleAppointmentModal}
          onHide={handleCloseModal}
          appointmentId={results[0]?.appointmentId}
          hasSessionStarted={results[0]?.HasSessionStarted}
          clientName={results[0]?.ClientName}
          requesterName={results[0]?.RequesterName}
          dateTime={results[0]?.message}
          type={results[0]?.Channel}
          communicationTypeIdentification={results[0]?.CommunicationTypeIdentification}
      />) : (<RemindarScheduleAppointmentModal
        show={isOpenRemindarScheduleAppointmentModal}
        onHide={() => handleCloseModal()}
        onClose={() => handleCloseModal()}
        title={remindarMessage}
        appointmentId={latestAppointmentId}
      />)
    }
    </>
  )
}

export {RemindarSignalRHub}
